module.exports = __webpack_public_path__ + "img/avatar_10.e4a0807e.svg";